import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Save = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Save({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      d='M6.75 20.25H17.25V12.75H6.75V20.25ZM15.5 15.75C15.7761 15.75 16 15.9739 16 16.25V16.75C16 17.0261 15.7761 17.25 15.5 17.25H8.5C8.22386 17.25 8 17.0261 8 16.75V16.25C8 15.9739 8.22386 15.75 8.5 15.75H15.5ZM15.5 13.75C15.7761 13.75 16 13.9739 16 14.25V14.75C16 15.0261 15.7761 15.25 15.5 15.25H8.5C8.22386 15.25 8 15.0261 8 14.75V14.25C8 13.9739 8.22386 13.75 8.5 13.75H15.5ZM8.17285 7.11719H15.25V3.75H8.17285V7.11719ZM16.75 7.36719C16.75 8.05754 16.1904 8.61719 15.5 8.61719H7.92285C7.2326 8.61707 6.67285 8.05747 6.67285 7.36719V3.75H4.25V20.25H5.25V12.0996C5.25021 11.6305 5.63048 11.2502 6.09961 11.25H17.9004C18.3695 11.2502 18.7498 11.6305 18.75 12.0996V20.25H19.75V6.71191L16.75 3.7627V7.36719ZM21.25 20.9004C21.2498 21.3695 20.8695 21.7498 20.4004 21.75H3.59961C3.13047 21.7498 2.75021 21.3695 2.75 20.9004V3.09961C2.75021 2.63048 3.13048 2.25021 3.59961 2.25H16.8389C17.1257 2.25 17.4027 2.34879 17.624 2.52734L17.7158 2.6084L20.876 5.71582C21.115 5.95079 21.25 6.27227 21.25 6.60742V20.9004Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'save-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Save;
